import React from "react";
//Third Party
import { useTable, useSortBy} from "react-table";
import "jspdf-autotable";
//Styles

import { useNavigate } from "react-router-dom";
import {
  CustomPagination,
  SquireIconWrapper,
} from "../../lib";
import { KTIcon } from "../../../../../_metronic/helpers";
import moment from "moment-jalaali";

interface LogTableProps {
  data: {
    tickets: any[];
    totalRows: number;
  };
  queryString: {
    page: number;
    nationalCode: string;
  };
  matchId: number; // matchId رو به عنوان prop جداگانه دریافت می‌کنیم
  setQueryString: (page: number) => void;
  refetch: () => void;
}
const FanReportLogTable: React.FC<LogTableProps> = ({
  data,
  queryString,
  setQueryString,
  refetch,
}) => {

  const columns = React.useMemo(
    () => [
      {
        Header: <HeaderTextIcon text={"ردیف"} />,
        id: 'row_number',
        Cell: ({ row }: any) => (
          <span className="rowNum">
            {(queryString.page - 1) * 10 + row.index + 1}
          </span>
        ),
      },
      {
        Header: <HeaderTextIcon text={"نام و نام خانوادگی خریدار"} />,
        id: 'user_name',
        accessor: (row: any) => `${row.user.f_name} ${row.user.l_name}`,
        Cell: ({ value }: any) => value,
      },
      {
        Header: <HeaderTextIcon text={"شماره موبایل خریدار"} />,
        id: 'mobile',
        accessor: (row: any) => row.user.mobile,
        Cell: ({ value }: any) => value,
      },
      {
        Header: <HeaderTextIcon text={"کد ملی خریدار"} />,
        id: 'national_code',
        accessor: (row: any) => row.user.national_code,
        Cell: ({ value }: any) => value,
      },
      {
        Header: <HeaderTextIcon text={"تاریخ صدور بلیط"} />,
        id: 'created_at',
        accessor: 'created_at',
        Cell: ({ value }: any) => moment(value).format('jYYYY/jMM/jDD HH:mm'),
      },
      {
        Header: <HeaderTextIcon text={"وضعیت"} />,
        id: 'status',
        accessor: 'status',
        Cell: ({ value }: any) => (
          <span className={`badge badge-light-${value === 'booked' ? 'success' : value === 'reserved' ? 'warning' : 'danger'}`}>
            {value === 'booked' ? 'خریداری شده' : value === 'reserved' ? 'رزرو شده' : 'لغو شده'}
          </span>
        ),
      },
      {
        Header: <HeaderTextIcon text={"مبلغ"} />,
        id: 'price',
        accessor: 'price',
        Cell: ({ value }: any) => value?.toLocaleString() + " ریال",
      },
      {
        Header: <HeaderTextIcon text={"نحوه پرداخت"} />,
        id: 'payMethod',
        accessor: 'payMethod',
        Cell: ({ value }: any) => value === 'online' ? 'آنلاین' : 'حضوری',
      },
    ],
    [queryString.page]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns: columns as any,
      data: data?.tickets || [],
    },
    useSortBy
  );

  return (
    <div className="p-c-30">
      <div style={{ overflow: "auto" }}>
        <table
          {...getTableProps()}
          className="table align-middle table-row-dashed fs-6 gy-5"
        >
          <thead>
            {headerGroups.map((headerGroup: any) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column: any) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row: any) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell: any) => (
                    <td {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-end mt-5">
        <CustomPagination
          activePage={queryString.page}
          setQueryString={setQueryString}
          totalRows={data?.totalRows}
          numberInPage={10}
        />
      </div>
    </div>
  );
};

const HeaderTextIcon = ({ text }: { text: string }) => (
  <div className="d-flex align-items-center justify-content-center gap-2">
    <span>{text}</span>
    <KTIcon iconName="filter" className="fs-5" />
  </div>
);

const IconsCell = ({ league, page }: any) => {
  const icons = [
    {
      iconClass: "fc-12 color-yellow-c",
      iconName: "pencil",
      wrapperClass: "bg-light-yellow-c",
    },
    {
      iconClass: "fc-12 color-red-c",
      iconName: "trash",
      wrapperClass: "bg-light-red-c",
    },
  ];
  const navigate = useNavigate();
  const [delItem, setDelItem] = React.useState<any>(null);
  const [showDelModal, setShowDelModal] = React.useState<boolean>(false);
  const handleActionClick = (icon: any, team: any) => {
    if (icon.iconName === "pencil") {
      navigate(`/leagues/edit-league?page=${page}`, { state: team });
    } else {
      setDelItem(() => {
        return {
          id: league.id,
        };
      });
      setShowDelModal(true);
    }
  };
  return (
    <>
      <div className={"IconCell"}>
        {icons.map((icon) => (
          <a onClick={(e) => handleActionClick(icon, league)}>
            <SquireIconWrapper {...icon} />
          </a>
        ))}
      </div>
    </>
  );
};

export default FanReportLogTable;
